"use client";

import dynamic from "next/dynamic";

const Pengumuman = dynamic(() => import("@/app/Components/Pages/Pengumuman"), {
    ssr: false
});

export default function PengumumanWrapper() {
  return <Pengumuman />;
}
